import { AsyncPipe, NgClass } from '@angular/common';
import { Component, DestroyRef, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatToolbar } from '@angular/material/toolbar';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';

import { CommonService, LoginService, WindowService } from '@app/services';
import { AuthService, User } from '@auth0/auth0-angular';
import { environment } from '@env/environment';
import { filter, map, Observable } from 'rxjs';
import { NavigationMenuComponent } from '../navigation-menu/navigation-menu.component';
import { SubnavMenuComponent } from '../subnav-menu/subnav-menu.component';

@Component({
  selector: 'qb-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    MatToolbar,
    NgClass,
    MatIcon,
    RouterLink,
    NavigationMenuComponent,
    MatButton,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    SubnavMenuComponent,
    AsyncPipe,
  ],
})
export class HeaderComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  @Output() toggleSideNav: EventEmitter<boolean> = new EventEmitter<boolean>();

  displayName: string = '';
  isAuthenticated$ = this.auth.isAuthenticated$;
  isPhoneOrTablet$: Observable<boolean> = this.windowService.isPhoneOrTablet$.pipe(takeUntilDestroyed(this.destroyRef));

  isCupccaa: Observable<boolean>;

  currentUser: Observable<User>;

  get titleText(): string {
    let _titleText = '';

    if (this.loginService.isVendor) {
      _titleText = this.loginService.user.companyName;
    }
    if (this.loginService.isAgency) {
      _titleText = this.loginService.user.agencyName;
    }
    if (this.loginService.isQbat) {
      _titleText = 'QualityBidders';
    }

    return _titleText;
  }

  get logoLink(): string {
    let _logoLink = '';

    if (this.loginService.isVendor) {
      _logoLink = '/vendor';
    }
    if (this.loginService.isAgency) {
      _logoLink = '/agency';
    }
    if (this.loginService.isQbat) {
      _logoLink = '/qbat/prequalification';
    }

    return _logoLink;
  }

  constructor(
    private commonService: CommonService,
    private auth: AuthService,
    private router: Router,
    private windowService: WindowService,
    private loginService: LoginService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.currentUser = this.auth.user$.pipe(takeUntilDestroyed(this.destroyRef));
    this.isCupccaa = this.router.events.pipe(
      filter(val => val instanceof NavigationEnd),
      map(() => {
        return window.location.pathname.includes('cupccaa');
      })
    );

    // this.userService.currentUserRoutes().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(routes => {
    // 	const items: UserRoleRoute[] = [];
    // 	routes.forEach(route => {
    // 		if (route.routeType === UserRoleRouteType.MAINMENU) {
    // 			items.push(route);
    // 		}
    // 	});
    // 	this.menuItems = [...items];
    // });
  }

  login() {
    this.loginService.login();
  }

  signUp() {
    const url = `https://${environment.auth0Domain}/authorize?prompt=login&response_type=code&client_id=${environment.auth0ClientId}&redirect_uri=${environment.auth0CallbackUrl}&screen_hint=signup`;
    window.location.href = url;
  }

  onLogout(): void {
    this.loginService.logOut();
  }

  toggleNav() {
    this.toggleSideNav.emit(true);
  }
}
